// 项目列表
import axios from '@/libs/api.request'

// 获取项目列表根据人员
export const listMyProjects = (data) => {
  return axios.request({
    data: data,
    url: '/api/project/listMyProjects',
    method: 'post'
  })
}
// 选择项目
export const switchMyCurrentProject = (data) => {
  return axios.request({
    data: data,
    url: '/api/project/switchMyCurrentProject',
    method: 'post'
  })
}
// 存储路径
export const cunchuUrl = (data) => {
  return axios.request({
    data: data,
    url: '/api/project/Contract/cunchuUrl',
    method: 'post'
  })
}
// office路径
export const officeUrl = (data) => {
  return axios.request({
    data: data,
    url: '/api/project/Contract/officeUrl',
    method: 'post'
  })
}
